import { render, staticRenderFns } from "./warehouseLabelA4.vue?vue&type=template&id=d0946098&scoped=true&"
import script from "./warehouseLabelA4.vue?vue&type=script&lang=js&"
export * from "./warehouseLabelA4.vue?vue&type=script&lang=js&"
import style0 from "./warehouseLabelA4.vue?vue&type=style&index=0&id=d0946098&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0946098",
  null
  
)

export default component.exports